<template>
  <div>
    <slot v-if="renderModal" />
  </div>
</template>

<script>
export default {
    name: 'ModalWrapper',
    data() {
        return {
            renderModal: false
        }
    },
    mounted() {
        this.$on('hidden', this.onHidden)
    },
    beforeDestroy() {
        this.$off('hidden', this.onHidden)
    },
    methods: {
        onHidden() {
            this.renderModal = false
        },
        show(params) {
            this.renderModal = true
            this.$nextTick(() => {
                this.$slots.default[0].componentInstance.show(...(params || []))
            })
        },
        hide(params) {
            this.$nextTick(() => {
                this.$slots.default[0].componentInstance.hide(...(params || []))
            })
        }
    }
}
</script>

<style scoped>

</style>
